export default "/images/vendor/flag-icon-css/flags/4x3/cm.svg?b09bb372e446f5ca1accd57750226793";